import { createReducer } from "redux-act";
import createAction from "./utils/createMetaAction";
export const updateRowViewVisibleRange = createAction("updateRowViewVisibleRange");
export default createReducer(
  {
    [updateRowViewVisibleRange]: (state, payload) => {
      return payload;
    }
  },
  { start: -1, end: -1 }
);
